import { render, staticRenderFns } from "./HRegBasic.vue?vue&type=template&id=40724190&scoped=true"
import script from "./HRegBasic.vue?vue&type=script&lang=js"
export * from "./HRegBasic.vue?vue&type=script&lang=js"
import style0 from "./HRegBasic.vue?vue&type=style&index=0&id=40724190&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40724190",
  null
  
)

export default component.exports